var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "-1 -6 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.4240175,14.729269 L7.6752116,10.2307019 C7.26826189,9.74236222 7.61551833,9.00095527 8.25119409,9.00095527 L15.7488059,9.00095527 C16.3844817,9.00095527 16.7317381,9.74236222 16.3247884,10.2307019 L12.5759825,14.729269 C12.2762316,15.08897 11.7237684,15.08897 11.4240175,14.729269 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#668592",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretDown);
export default __webpack_public_path__ + "static/media/icon-caret-down.baeef59c.svg";
export { ForwardRef as ReactComponent };